import React, { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import groupBy from 'lodash/groupBy';
import { Spin } from 'antd';
import Panel from 'common/Panel';
import TitlePanel from 'common/TitlePanel';
import queries from 'graph/queries';
import ReportPanel from 'common/ReportPanel';
import ProgressGraph from './ProgressGraph';

const Progress = () => {
  const { loading, data } = useQuery(queries.carePlansComplete, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  });

  const carePlans = data?.carePlans || [];
  const carePlanActivities = carePlans.flatMap(
    (carePlan) => carePlan?.carePlanActivities ?? [],
  );

  const activities = useMemo(() => {
    const graphedQuestionnaires = carePlanActivities
      .filter((activity) => activity?.plannable?.__typename === 'Questionnaire')
      .filter(
        (questionnaire) =>
          questionnaire.plannable?.properties?.displayGraph !== false,
      );

    return groupBy(graphedQuestionnaires, 'plannable.id');
  }, [carePlanActivities]); // This calculation only re-runs when `carePlanActivities` data changes

  const isEmpty = Object.keys(activities).length === 0;
  if (loading && isEmpty) {
    return (
      <>
        <TitlePanel className="pa3 flex items-center justify-center primary">
          <h1>Check out your Progress</h1>
        </TitlePanel>
        <Panel id="scene-progress" className="pa3-ns pa0">
          <div
            className="w-100 overflow-auto ph4-ns ph0 flex items-center justify-center"
            style={{ minHeight: '400px' }}
          >
            <Spin size="large" />
          </div>
        </Panel>
      </>
    );
  }

  return (
    <>
      <TitlePanel className="pa3 flex items-center justify-center primary">
        <h1>Check out your Progress</h1>
      </TitlePanel>
      <Panel id="scene-progress" className="pa3-ns pa0">
        <div className="w-100 overflow-auto ph4-ns ph0">
          {Object.entries(activities).map(([questionnaireId, group]) => (
            <ReportPanel
              key={questionnaireId}
              title={group[0]?.plannable?.title}
              className="mv3"
            >
              <ProgressGraph questionnaireId={questionnaireId} />
            </ReportPanel>
          ))}
          {isEmpty && (
            <div className="pa4 tc">
              <p className="mt4 mb0 ma0">
                This is where you will find your progress graphs.
              </p>
            </div>
          )}
        </div>
      </Panel>
    </>
  );
};

export default Progress;
